import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Select, Tag, InputNumber } from "antd";
import {
  DollarOutlined,
  CloseOutlined,
  SaveOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import "./addAndUpdateCorporateRentalDiscount.css";

const { Option } = Select;

const CorporateRentalDiscountEditModal = ({ visible, onClose, discountData, onSave }) => {
  const [form] = Form.useForm();
  const discountType = Form.useWatch("discount_type", form);

  useEffect(() => {
    if (visible && discountData) {
      form.setFieldsValue({
        domain_name: discountData.domain_name,
        discount_type: discountData.discount_type,
        discount_amount: discountData.discount_amount,
        currency: discountData.currency,
        reward_credit: discountData.reward_credit,
        status: discountData.status || "active",
      });
    } else if (visible) {
      form.resetFields();
      form.setFieldsValue({ discount_type: "amount" });
    }
  }, [visible, discountData, form]);

  const handleNumberInputWheel = (e) => {
    e.target.blur();
  };

  const handleFinish = (values) => {
    const payload = {
      domain_name: values.domain_name,
      discount_type: values.discount_type,
      ...(values.discount_type === "amount"
        ? { discount_amount: values.discount_amount, currency: values.currency }
        : { reward_credit: values.reward_credit }),
      ...(discountData?._id && { status: values.status }),
    };
    onSave(payload);
  };

  const modalTitle = (
    <div className="crd-edit-modal-header-content">
      <div className="crd-edit-header-icon-wrap">
        <DollarOutlined style={{ color: "white", fontSize: 18 }} />
      </div>
      <div className="crd-edit-header-text">
        <span className="crd-edit-header-title">
          {discountData?._id ? "Edit Corporate Rental Discount" : "Create Corporate Rental Discount"}
        </span>
        <span className="crd-edit-header-subtitle">
          {discountData?._id ? "Update discount details below" : "Fill in the details to create a discount"}
        </span>
      </div>
    </div>
  );

  return (
    <Modal
      title={modalTitle}
      open={visible}
      onCancel={onClose}
      closeIcon={<CloseOutlined style={{ color: "white", fontSize: 16 }} />}
      footer={null}
      destroyOnClose
      width={560}
      className="crd-edit-modal-override"
      styles={{
        header: {
          background: "#070C18",
          borderRadius: "14px 14px 0 0",
          padding: "20px 24px",
          borderBottom: "none",
        },
        body: {
          padding: "0",
          background: "#f4f6fb",
        },
      }}
    >
      <div className="crd-edit-modal-form">
        <Form form={form} layout="vertical" onFinish={handleFinish}>

          <div className="crd-section">
            <div className="crd-section-label">
              <AppstoreOutlined className="crd-section-icon" />
              <span>Discount Details</span>
            </div>

            <Form.Item
              label="Domain Name"
              name="domain_name"
              rules={[{ required: true, message: "Please enter domain name" }]}
            >
              <Input
                size="large"
                placeholder="e.g. company.com"
                className="crd-edit-input-override"
              />
            </Form.Item>

            <Form.Item
              label="Discount Type"
              name="discount_type"
              rules={[{ required: true, message: "Please select discount type" }]}
            >
              <Select size="large" placeholder="Select discount type" className="crd-edit-input-override">
                <Option value="amount">Amount</Option>
                <Option value="credit">Credit</Option>
              </Select>
            </Form.Item>

            {discountType === "amount" && (
              <div className="crd-edit-grid">
                <Form.Item
                  label="Discount Amount"
                  name="discount_amount"
                  rules={[{ required: true, message: "Please input discount amount" }]}
                >
                  <InputNumber
                    size="large"
                    min={0}
                    placeholder="e.g. 5000"
                    className="crd-edit-input-override"
                    style={{ width: "100%" }}
                    onWheel={handleNumberInputWheel}
                  />
                </Form.Item>

                <Form.Item
                  label="Currency"
                  name="currency"
                  rules={[{ required: true, message: "Please select currency" }]}
                >
                  <Select size="large" placeholder="Select currency" className="crd-edit-input-override">
                    <Option value="INR">INR</Option>
                    <Option value="USD">USD</Option>
                  </Select>
                </Form.Item>
              </div>
            )}

            {discountType === "credit" && (
              <Form.Item
                label="Reward Credit"
                name="reward_credit"
                rules={[{ required: true, message: "Please input reward credit" }]}
              >
                <InputNumber
                  size="large"
                  min={0}
                  placeholder="e.g. 500"
                  className="crd-edit-input-override"
                  style={{ width: "100%" }}
                  onWheel={handleNumberInputWheel}
                />
              </Form.Item>
            )}

            {discountData?._id && (
              <Form.Item label="Status" name="status" initialValue="active">
                <Select size="large" className="crd-edit-input-override">
                  <Option value="active">
                    <Tag color="green" style={{ margin: 0 }}>Active</Tag>
                  </Option>
                  <Option value="inactive">
                    <Tag color="red" style={{ margin: 0 }}>Inactive</Tag>
                  </Option>
                </Select>
              </Form.Item>
            )}
          </div>

          <div className="crd-footer">
            <Button
              size="large"
              onClick={onClose}
              className="crd-edit-btn crd-edit-btn-cancel"
            >
              Cancel
            </Button>
            <Button
              htmlType="submit"
              size="large"
              icon={<SaveOutlined />}
              className="crd-edit-btn crd-edit-btn-primary"
            >
              <span className="crd-update-btn">
                {discountData?._id ? "Update Discount" : "Create Discount"}
              </span>
            </Button>
          </div>

        </Form>
      </div>
    </Modal>
  );
};

export default CorporateRentalDiscountEditModal;